export default () => ({
  searchForm: {
    search: null,
  },
})
